import { ElementRef } from '@angular/core';

export interface ScrollDirective {
  legaltextRef: ElementRef;
  footerRef: ElementRef;
  headerRef?: ElementRef;
}
